import React from "react";

// assets
import notFoundImage from "../../../assets/images/img/404.svg"

const NotFound = () => {
  return (
    <div className="salemain mt-5">
      <img src={notFoundImage} alt="websitemaintenance" className="img-fluid  mx-auto d-block" />
    </div>
  );
}

export default NotFound;